/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createConditionalNode } from '../../factoriesAny.js';
export var ConditionalNodeDependencies = {
  NodeDependencies,
  createConditionalNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesConditionalNode.generated.js
// module id = 530
// module chunks = 2